import React, { useEffect, useState } from 'react';

import { TEAM_DEFAULT_LOGO } from 'shared/constants/links';
import { DivProps } from 'typings';
import * as S from './styles';

export type TeamLogoProps = DivProps & {
  url?: string | null;
  name?: string;
  size?: number;
  /** `square` — квадрат с рамкой (по умолчанию); `round` — круг на белой подложке, без рамки. */
  shape?: S.TeamLogoShape;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Эмблема команды. Нет ссылки или картинка не загрузилась — запасная эмблема `TEAM_DEFAULT_LOGO`,
 * как в списках команд: битая ссылка не оставляет пустого места.
 */
const TeamLogo = ({ url, name, size, shape = 'square', ...rest }: TeamLogoProps) => {
  const [isBroken, setIsBroken] = useState(false);

  // Другая эмблема — другая попытка: ошибку предыдущей ссылки с неё не переносим.
  useEffect(() => setIsBroken(false), [url]);

  const src = !url || isBroken ? TEAM_DEFAULT_LOGO : url;

  return (
    <S.TeamLogoContainer {...rest} size={size} shape={shape} data-shape={shape}>
      <S.TeamLogoImage
        src={src}
        alt=""
        data-testid="team-logo-image"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => setIsBroken(true)}
      />
    </S.TeamLogoContainer>
  );
};

export default TeamLogo;
